import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Box, CircularProgress, Typography, styled } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect, useRef, useState } from "react";
import { getCardVelocity } from "../Services/apiRoutes";
import StoryVelocityCard from "../components/StoryVelocityCard";
import CardVelocityFullView from "../components/CardVelocityFullView";
import { SocialIcon } from "react-social-icons";
import ToolTip from "../components/ToolTip";
import QuestionMarkSvg from '../components/QuestionMarkSvg'


const StoryVelocity = () => {
  const [cardsData, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  //   const [iconURL, setIconURL] = useState({});

  const isFetched = useRef(false);

  const [cardDetails, setCardDetails] = useState({});
  const [smallCardopen, setSmallCardOpen] = useState(false);
  const [readMoreopen, setreadMoreopen] = useState(false);

  const onReadMore = (cardDetails) => {
    setSmallCardOpen(false);
    setCardDetails(cardDetails);
    setreadMoreopen(true);
  };
  const handleReadMoreCardClose = () => {
    setSmallCardOpen(false);
    setreadMoreopen(false);
    // setCardDetails(false);
  };
  const onRowClick = (row) => {

    let details = {
      positive: true,
      title: row.title,
      text: row.text,
      category: row.Category,
      channel: row.channel,
      coins: row.coins,
      curated: row.curated,
      score: row.social_velocity,
      handle: row.handle,
      icons: {},
      datetime: row.datetime,
    };
    setCardDetails(details);
    setSmallCardOpen(true);
  }
  const handleSmallCardClose = () => {
    setSmallCardOpen(false);
    // setCardDetails(false);
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#D5B458",
      color: theme.palette.common.black,
      padding: "10px 20px",
      borderRight: "1px solid #FFFFFF",
      fontFamily: "Inter",
      marginTop: "2px",
      fontWeight: "800",
      align: "center",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 20,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const fetchCardsData = async () => {
    try {
      const data = await getCardVelocity();

      setCards(data["data"]);
    } catch (error) {
      console.log("in history curated", error);
    } finally {
      setLoading(false);
    }
  };

  // Below code is for check screen-size;
  const [isMobile, setIsMobile] = React.useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener to handle window resize
    window.addEventListener('resize', handleResize);

    // Initial check for mobile
    setIsMobile(window.innerWidth <= 768);

    // Clean up event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  //End  
  useEffect(() => {
    if (!isFetched.current) {
      fetchCardsData();
      isFetched.current = true;
    }
  }, []);
  return (

    <Box position="relative" maxWidth="900px" margin="20px auto">


      <ToolTip arrow title={"At Auro Digital we listen to  what’s Trending in  Crypto and Digital Assets, on news and social media channels, that we correlate with Price action and share with our clients as ideational tools."} placement="top" enterTouchDelay={0}>

        <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "center", marginTop: "10px", marginBottom: "30px" }}>
          <Typography sx={{ fontWeight: "bold", textAlign: "center" }} variant={isMobile ? "h5" : "h4"}>
            Story Velocity
          </Typography>
          <div style={{ marginLeft: "5px" }}>
            {
              isMobile ?
                (
                  <QuestionMarkSvg />
                ) : (
                  <div />
                )}
          </div>
        </Box>
      </ToolTip>

      {smallCardopen && <StoryVelocityCard open={smallCardopen} handleClose={handleSmallCardClose} category={cardDetails.category} icons={{}} title={cardDetails.title} text={cardDetails.text} curated={cardDetails.curated} score={cardDetails.score} channel={cardDetails.channel} coins={cardDetails.coins} handle={cardDetails.handle} datetime={cardDetails.datetime} onReadMore={onReadMore} />}

      {readMoreopen && <CardVelocityFullView open={readMoreopen} handleClose={handleReadMoreCardClose} cardDetails={cardDetails} />}

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "50px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <CircularProgress />
        </div>
      ) : (

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead
              style={{
                backgroundColor: "black",
                color: "white",
              }}
            >
              <TableRow >
                <StyledTableCell>#</StyledTableCell>
                <StyledTableCell align="center" fontWeight="bold">Heading</StyledTableCell>
                <StyledTableCell align="center">Channel</StyledTableCell>
                <StyledTableCell align="center">Rating</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cardsData.map((row, index) => (

                <StyledTableRow onClick={() => onRowClick(row)} key={index}>

                  <StyledTableCell component="th" scope="row">
                    {index + 1}
                  </StyledTableCell>

                  <StyledTableCell width={300} align="center" component="th" scope="row">
                    {(row.title === null || row.title === undefined || row.title.trim() === "") ? row.text.slice(0, 60) : row.title.slice(0, 60) + ".."}
                  </StyledTableCell>

                  <StyledTableCell align="center">
                    {
                      <SocialIcon
                        network={row.channel.toLowerCase()}
                        style={{
                          width: "27px",
                          height: "27px",
                        }}
                      />
                    }
                  </StyledTableCell>

                  <StyledTableCell align="center" component="th" scope="row">
                    <Box display="inline-flex" alignItems="center" gap={3}>
                      <Box>
                        <Typography fontSize={20} >{row.type}</Typography>
                      </Box>
                      <Box>
                        <Typography color="#D5B458" fontSize={20}>  {(row.social_velocity * 100).toFixed(0)}% </Typography>
                      </Box>
                    </Box>
                  </StyledTableCell>

                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        // <Grid
        //   container
        //   sx={{
        //     justifyContent: "center",
        //     marginTop: "20px",
        //     gap: "2.5vw",
        //     display: "flex",
        //   }}
        //   className="grid-container"
        // >
        //   <Grid container alignContent="flex-start" gap="3vw" width="48.5%" maxWidth="500px">
        //     {cardsData.map((sentiment) => (
        //       <Grid
        //         key={sentiment?._id}
        //         item
        //         sx={{
        //           width: "100%",
        //         }}
        //       >
        //         <StoryVelocityCard  category={sentiment.Category} icons={{}} title={sentiment.title} text={sentiment.text} curated={sentiment.curated} score={sentiment.social_velocity} channel={sentiment.channel} coins={sentiment.coins} handle={sentiment.handle} datetime={sentiment.datetime} onReadMore={onReadMore} />
        //       </Grid>
        //     ))}
        //   </Grid>

        //   <Grid container alignContent="flex-start" gap="3vw" width="48.5%" maxWidth="500px">
        //     {cardsData.map((sentiment) => (
        //       <Grid
        //         key={sentiment?._id}
        //         item
        //         sx={{
        //           width: "100%",
        //         }}
        //       >
        //         <StoryVelocityCard  category={sentiment.Category} icons={{}} title={sentiment.title} text={sentiment.text} curated={sentiment.curated} score={sentiment.social_velocity} channel={sentiment.channel} coins={sentiment.coins} handle={sentiment.handle} datetime={sentiment.datetime} onReadMore={onReadMore} />
        //       </Grid>
        //     ))}
        //   </Grid>
        // </Grid>
      )}
      <div
        style={{
          // display:isTablet?"flex":"auto",
          height: "100px",
        }}
        id="loadMore"
      ></div>
    </Box>
  );
};

export default React.memo(StoryVelocity);
